import { render } from "./AddContactorView.vue?vue&type=template&id=5f80f074&scoped=true"
import script from "./AddContactorView.vue?vue&type=script&lang=js"
export * from "./AddContactorView.vue?vue&type=script&lang=js"

import "./AddContactorView.vue?vue&type=style&index=0&id=5f80f074&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f80f074"]])

export default __exports__